"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Fields_1 = require("./Fields");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return Fields_1.default; } });
